// Thumbnails of photos taken on another device: fetched from SharePoint the
// first time an area shows them, then kept for as long as the app is open.
// Not stored on the device, so offline they show as a placeholder.
import { getPhotoContent } from './api';
import { thumbnailOf } from './photo-resize';

const loaded = new Map<string, Promise<string | null>>();

async function fetchThumbnail(areaId: string, photoId: string): Promise<string | null> {
  try {
    // SharePoint's thumbnail, not the full photo: a fraction of the bytes on the iPad's mobile data (#533).
    return await thumbnailOf(await getPhotoContent(areaId, photoId, 'thumbnail'));
  } catch {
    return null;
  }
}

/** The photo's thumbnail as a data: URL; null when it can't be fetched (no signal, or gone from SharePoint). */
export function remoteThumbnail(areaId: string, photoId: string): Promise<string | null> {
  const existing = loaded.get(photoId);
  if (existing) return existing;
  const load = fetchThumbnail(areaId, photoId).then((url) => {
    // A failure isn't kept: the next showing tries again.
    if (url === null) loaded.delete(photoId);
    return url;
  });
  loaded.set(photoId, load);
  return load;
}
